'use client';

export { default } from './SwipeableDrawer';